if (!customElements.get('ws-design-card')) {
  customElements.define('ws-design-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.colors = [...this.querySelectorAll('[data-color]')];
      this.views = [...this.querySelectorAll('[data-view]')];
      this.addEventListener('click', event => {
        this.syncControls();
        if (!this.color) return;
        const color = event.target.closest('[data-color]');
        const view = event.target.closest('[data-view]');
        if (color) { this.color = color; this.showModel = false; this.render(); }
        if (view) { this.side = view.dataset.view; this.render(); }
        if (event.target.closest('.ws-card__inset, .ws-card__flip')) {
          if (this.color.dataset.single === 'true') this.showModel = !this.showModel;
          else this.side = this.side === 'front' ? 'back' : 'front';
          this.render();
        }
      });
      this.color = this.colors[0];
      if (!this.color) { this.querySelector('.ws-card__inset').hidden = true; return; }
      this.side = this.color.dataset.side;
      this.render();
    }
    syncControls() {
      this.colors = [...this.querySelectorAll('[data-color]')];
      this.views = [...this.querySelectorAll('[data-view]')];
      if (!this.colors.includes(this.color)) {
        this.color = this.colors.find(b => b.getAttribute('aria-pressed') === 'true') || this.colors[0];
        this.side = this.color?.dataset.side || 'front';
      }
    }
    render() {
      this.syncControls();
      if (!this.color) return;
      const data = this.color.dataset;
      const opposite = this.side === 'front' ? 'back' : 'front';
      const label = this.dataset[this.side];
      const more = this.querySelector('.ws-card__more');
      const remaining = Math.max(0, Number(this.dataset.totalColors || 0) - this.colors.length);
      if (more) { more.hidden = !remaining; more.textContent = `+${remaining}`; more.setAttribute('aria-label', (this.dataset.moreTemplate || '__COUNT__ more colors').replace('__COUNT__', remaining)); }
      const single = data.single === 'true';
      this.classList.toggle('ws-card--single', single);
      const otherLabel = single ? this.dataset.model : this.dataset[opposite];
      const main = this.querySelector('.ws-card__main');
      if (!data[this.side]) this.side = data.side || 'front';
      main.src = data[this.side];
      main.alt = `${this.dataset.title} — ${data.color} — ${label}`;
      const inset = this.querySelector('.ws-card__inset');
      inset.disabled = false;
      const singleModel = data[`${this.side}Model`];
      inset.hidden = single && !singleModel;
      if (single && this.showModel && singleModel) main.src = singleModel.replace('width=500', 'width=1200');
      const insetLabel = single ? (this.showModel ? label : this.dataset.model) : otherLabel;
      inset.querySelector('img').src = single ? (this.showModel ? data[this.side] : (singleModel || data[this.side])) : (data[`${opposite}Model`] || data[opposite]);
      inset.querySelector('img').alt = `${this.dataset.title} — ${data.color} — ${insetLabel}`;
      inset.querySelector('span').textContent = single ? (this.showModel ? label : '') : otherLabel;
      inset.querySelector('span').hidden = single && !this.showModel;
      inset.setAttribute('aria-label', insetLabel);
      this.querySelector('.ws-card__view').textContent = single && this.showModel ? '' : label;
      const flip = this.querySelector('.ws-card__flip');
      if (flip) { flip.textContent = `${label} ↔`; flip.setAttribute('aria-label', otherLabel); }
      this.querySelectorAll('.ws-card__main-link, .ws-card__title, .ws-card__more').forEach(a => { const url = new URL(data.href, location.origin); url.searchParams.set('view', `ws-${this.side}`); a.href = url.href; });
      this.querySelector('.ws-card__price').textContent = data.price;
      this.querySelector('.ws-card__selection').textContent = data.color;
      const family = this.querySelector('.ws-card__family');
      family.replaceChildren();
      if (data.family === 'grit' || data.family === 'gladness') {
        const link = document.createElement('a');
        link.href = this.dataset[data.family + 'Url'];
        link.textContent = data.family;
        link.setAttribute('aria-label', 'Shop ' + data.family + ' designs');
        family.append(link);
      }
      family.classList.toggle('ws-card__family--gladness', data.family === 'gladness');
      this.colors.forEach(b => b.setAttribute('aria-pressed', String(b === this.color)));
      this.views.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.view === this.side)));
    }
  });
}


